// extracted by mini-css-extract-plugin
export const slider_main = "articles-module--slider_main--1iqDM";
export const maintTitle = "articles-module--maintTitle--1w8SI";
export const slider_btn = "articles-module--slider_btn--1b4Yv";
export const slider_card = "articles-module--slider_card--1V-VN";
export const slider_cardcontent = "articles-module--slider_cardcontent--26tTA";
export const slider_belowbtn = "articles-module--slider_belowbtn--LCgjR";
export const slider_belowbtn1 = "articles-module--slider_belowbtn1--1vb5w";